import {Component, Input, output} from '@angular/core';
import {VVPMActivity} from "../../../models/vvpm-activity.model";
import {DetailedViewObjectService} from "../../../services/detailed-view-object.service";
import {ContextMenuService} from "../../../services/context-menu.service";
import {DataObject} from "../../../models/metadata";
import {RdsIconComponent} from "@rds/angular-components";


@Component({
  selector: 'app-vvpm-activity',
  standalone: true,
  imports: [RdsIconComponent],
  templateUrl: './vvpm-activity.component.html',
  styleUrl: './vvpm-activity.component.scss'
})
export class VVPMActivityComponent {
  @Input() vvpmActivity!: VVPMActivity
  deleteVVPMActivity = output<DataObject>()

  constructor(private detailedObjectService: DetailedViewObjectService, private contextMenuService: ContextMenuService) {
  }

  onCardClick(){
    this.detailedObjectService.nextDetailedObject(this.vvpmActivity)
  }

  onContextMenu(_: MouseEvent){
    // VVPM activities are read-only, so no delete option
    // this.contextMenuService.addItemToNextOpen('vvpm-activity', () => {
    //   this.deleteVVPMActivity.emit(this.vvpmActivity as DataObject)
    // })
  }

  getContrastColor(hexColor?: string | null): string {
    const hex = (hexColor || '').replace('#','');
    if (hex.length !== 6) {
      return '#111827';
    }
    const r = parseInt(hex.substring(0,2), 16);
    const g = parseInt(hex.substring(2,4), 16);
    const b = parseInt(hex.substring(4,6), 16);
    const luminance = (0.299*r + 0.587*g + 0.114*b) / 255;
    return luminance > 0.6 ? '#111827' : '#FFFFFF';
  }

  getCombinedAudiences(): string[] {
    return this.vvpmActivity.getCombinedAudiences();
  }
}
